export const forgotPasswordConstraints = {
    email: { validEmail: true },
};
